import React, { useState, useContext } from "react";
import PageHeader from "../../../components/PageHeader";
import DataTable from "../../../components/DataTable";
import InventoryStorageDimsFilters from "./InventoryStorageDimsFilters";
import { getFilterState, saveFilterState } from "../../../utils";
import { INVENTORY_STORAGE_DIM_COLUMNS } from "./columns";
import { ALL_INVENTORY_STORAGE_DIMS_QUERY } from "../../../graphql/InventoryStorageDims/InventoryStorageDims.graphql";
import { ModalContext } from "../../../components/ModalProvider";
import { AddInventoryStorageDimForm } from "../../../components/InventoryStorageDims";

function InventoryStorageDimsPage() {
  const INITIAL_FILTER_STATE = getFilterState("INVENTORY_STORAGE_DIM_FILTERS", {
    Active: true
  });
  const { setModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("INVENTORY_STORAGE_DIM_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({});
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={InventoryStorageDimsFilters}
        columns={INVENTORY_STORAGE_DIM_COLUMNS}
        filters={filters}
        name="InventoryStorageDims"
        query={ALL_INVENTORY_STORAGE_DIMS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Storage Dimensions"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddInventoryStorageDimForm
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
      <DataTable
        columns={INVENTORY_STORAGE_DIM_COLUMNS}
        dataQuery={ALL_INVENTORY_STORAGE_DIMS_QUERY}
        name="InventoryStorageDim"
        where={{ ...filters }}
        onRowClick={data =>
          setModalOpen(
            true,
            <AddInventoryStorageDimForm
              data={data}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
}
InventoryStorageDimsPage.propTypes = {};
export default InventoryStorageDimsPage;
